import { IButtonStyles, IButtonProps } from '@fluentui/react';

export const TeamsButtonStyles = (_props: IButtonProps): Partial<IButtonStyles> => {
  return {
    root: {
      borderRadius: 4,
    },
  };
};
